
import Vue from 'vue'
import { CURRENT_USER_RESERVATION_RANGE_DATA, USER_LOGGED_IN } from '@/store/getter-types'
import Moment from 'moment'
import { formatAsIsoWeek } from '@/services/date-time'
import moment from 'moment'
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";
import {CurrentUser} from "@/model/CurrentUser";
import _, {indexOf} from "lodash";
import {Watch} from "vue-property-decorator";

export default Vue.extend({
  name: 'CurrentDailyMenu',

  props: {
    timeBlockCollection: {
      type: Array as () => BusinessTimeBlockCollection[],
      //default: DatePeriodEnum.Month
    },
    settingsData: {type: Array as () => any[]},
    currentUser: {type: Object as () => CurrentUser}

},

  watch: {
    clickOnCard(newVal: any): void {
      this.clickOnCard = newVal
    }
  },

  computed: {
    isMultiplePortion (): boolean {
      return this.currentUser.boarderList[0].customer.configuration.allow_multiple_portions

    },

    isBoarderNote(): boolean {
      return this.currentUser.boarderList[0].customer.configuration.allow_reservation_note

    },

    username (): string {
      let user = this.$store.getters[USER_LOGGED_IN]
      return user.fullName
    },

    reservationData (): any[] {
      let reservationData = this.$store.getters[CURRENT_USER_RESERVATION_RANGE_DATA]
      let currentData: any[] = []
      if (reservationData) {

        currentData = _(reservationData.reservationList)
            .groupBy('date') // Zoskupenie podľa dátumu
            .map((dateGroup, date) => {
              const groupedByTimeBlock = _(dateGroup)
                  .groupBy('timeBlock.title')
                  .map((timeBlockGroup, timeBlock) => {
                    const groupedOffers = _(timeBlockGroup)
                        .flatMap('reservedOffers')
                        .groupBy(offer => `${offer.dailyMenuOffer.referenceFoodItem.id}`) // Kľúč pre zoskupenie podľa ID jedla
                        .map((offerGroup, key) => {
                          const firstOffer = _.head(offerGroup);
                          return {
                            dailyMenuOffer: firstOffer.dailyMenuOffer,
                            amount: _.sumBy(offerGroup, 'amount') // Sčítanie amountov
                          };
                        })
                        .value();
                    return {
                      timeBlockTitle: timeBlock,
                      options: groupedOffers
                    }
                  })
                  .value();

              return {
                date: date,
                acceptanceStatus: dateGroup[0].acceptanceStatus ? dateGroup[0].acceptanceStatus.name : 'accepted',
                reservedOffers: groupedByTimeBlock,
                status: dateGroup[0].status, // Predpokladáme rovnaký status pre všetky objednávky v skupine
                boarderNote: dateGroup[0].boarderNote
              };
            })
            .value()

      }
      return currentData
    },

    isAcceptanceProcess(): boolean {
      let condition: boolean = false
      const foundItem: any = this.settingsData.find((c: any) => c.key ===  'tenant.allow_acceptance_process')
      if(foundItem){
        condition = foundItem.value === 'true'
      } else {
        condition = false
      }

      return condition
    }

  },

  methods: {

    isDivider (item: any) {
      if(item > 0) {
        return true

      }
    },

    amount (option: any): any {
      let data = this.$store.getters[CURRENT_USER_RESERVATION_RANGE_DATA]
      let foundItem: any | null = null
      let amount: any | null = null
      data.reservationList.forEach((item: any) => {
        item.reservedOffers.filter((i: any) => {
          foundItem = i.dailyMenuOffer.id === option.offer.id
          if(foundItem) {
            amount = i.amount
          }
        })

      })
      return amount
    },


    formatDate (date: Date): string {
      return Moment(date).format('D.M.Y')
    },

    formatNameDate (date: any): string {
      let tomorrow = Moment(new Date()).add(1, 'days')
      if (Moment(date).isSame(Moment(), 'day')) {
        return 'Dnes'
      } else if (Moment(date).isSame(tomorrow, 'day')) {
        return 'Zajtra'
      } else {
        return ''
      }

    },

    onDayMenuClick (date: Date): void {
      if(this.clickOnCard === true) {
        this.$router.push({
          'name': 'Order',
          params: {
            isoWeek: formatAsIsoWeek(date),
            date: moment(date).format('YYYY-MM-DD')
          }
        })
      }

    }
  },
  mounted() {
  },

  data () {
    return {
      size: '230',
      open: undefined,
      clickOnCard: true
    }
  }
})
